const pluralize = (time, label) => `${time + label}前`;
// 转换jobstatus
// export function tranlateJobStatus(status) {
//   const JOB_STATUS = ['丢弃任务', '未领取', '已领取', '已提交', '质检中', '待确认', '申诉中', '质检通过', '待返标', '返标完成'];
//   return JOB_STATUS[status + 1];
// }
// 转换jobstatus
export function tranlateProjectStatus(status) {
  if (!status && status !== 0) return "";
  const PROJECT_STATUS = [
    { name: "导入失败", color: "danger" },
    { name: "导入中", color: "warning" },
    { name: "待前置标注", color: "warning" },
    { name: "未编排", color: "primary" },
    { name: "已编排", color: "success" },
    { name: "标注中", color: "primary" },
    { name: "质检通过", color: "success" },
    { name: "冲突标注中", color: "primary" },
    { name: "已完成", color: "success" },
    { name: "未导入", color: "primary" }
  ];
  return PROJECT_STATUS[status + 3] !== undefined
    ? PROJECT_STATUS[status + 3]
    : { name: "未知", color: "danger" };
}
export function tranlateExportStatus(status) {
  console.log(status);
  if (!status && status !== 0) return "";
  const EXPORT_STATUS = [
    { name: "未导出", color: "warning" },
    { name: "导出中", color: "primary" },
    { name: "导出完成", color: "success" },
    { name: "导出失败", color: "danger" },
    { name: "未导入", color: "primary" }
  ];
  return EXPORT_STATUS[status] !== undefined
    ? EXPORT_STATUS[status]
    : { name: "未知", color: "danger" };
}
/* 字符串转日期 */
const parseDate = dateString => {
  let dateStr = dateString;
  if (dateStr !== 0 && !dateStr) {
    return new Date();
  }
  if (
    Number.isInteger(dateStr) ||
    /\+\d*:?\d*\s*$/.test(dateStr) ||
    /Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec/gi.test(dateStr)
  ) {
    return new Date(dateStr);
  }
  dateStr = `${dateStr}`.replace(/[^0-9]/g, "");
  const y = dateStr.substr(0, 4);
  const m = parseInt(dateStr.substr(4, 2) || "1", 10) - 1;
  const s = [y, m];
  let idx = 0;
  while (dateStr.length > idx * 2 + 6) {
    s.push(dateStr.substr(idx * 2 + 6, 2));
    idx += 1;
  }
  return new Date(...s);
};

const daysInMonth = (year, month) => 32 - new Date(year, month, 32).getDate();

export { parseDate, daysInMonth };

/* eslint-disable no-bitwise */
/* timeAgo */
export function timeAgo(time, now) {
  const between = (+parseDate(now).getTime() - +parseDate(time).getTime()) / 1000;
  if (between < 60) {
    return pluralize(~~between, " 秒");
  }
  if (between < 3600) {
    return pluralize(~~(between / 60), " 分钟");
  }
  if (between < 86400) {
    return pluralize(~~(between / 3600), " 小时");
  }
  if (between < 86400 * 30) {
    return pluralize(~~(between / 86400), " 天");
  }
  if (between < 86400 * 30 * 12) {
    return pluralize(~~(between / (86400 * 30)), "个月");
  }
  return pluralize(~~(between / (86400 * 30 * 12)), "年");
}

/* 日期格式化 */
export function formatDate(date, format) {
  if (!date) {
    return "-";
  }
  const d = parseDate(date);
  let fmt = format || "yyyy-MM-dd hh:mm:ss";
  const o = {
    "M+": d.getMonth() + 1, // 月份
    "d+": d.getDate(), // 日
    "h+": d.getHours(), // 小时
    "m+": d.getMinutes(), // 分
    "s+": d.getSeconds(), // 秒
    "q+": Math.floor((d.getMonth() + 3) / 3), // 季度
    S: d.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, `${d.getFullYear()}`.substr(4 - RegExp.$1.length));
  }
  Object.keys(o).forEach(k => {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
      );
    }
  });
  return fmt;
}

/**
 * 日期计算器
 * @param ndate 日期计算相对的日期、如果为空，取当前日期
 * @param compute 日期计算表达式，如果为字符串('y'代表年, 'm'代表月, 'w'代表周, 'd'代表日, 例如：'+1m +7d')，如果为数字则计算天数
 * @param defaultDate 表达式错误时的默认日期
 */
// appUtil.computeDate("2017-12-12", "-1d+2w");
export function computeDate(ndate, compute, defaultDate) {
  const offsetNumeric = offset => {
    const date = parseDate(ndate);
    date.setDate(date.getDate() + offset);
    return date;
  };
  const offsetString = offset => {
    const date = parseDate(ndate);
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();
    const pattern = /([+-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g;
    let matches = pattern.exec(offset);
    while (matches) {
      switch (matches[2] || "d") {
        case "d":
        case "D":
          day += parseInt(matches[1], 10);
          break;
        case "w":
        case "W":
          day += parseInt(matches[1], 10) * 7;
          break;
        case "m":
        case "M":
          month += parseInt(matches[1], 10);
          day = Math.min(day, daysInMonth(year, month));
          break;
        case "y":
        case "Y":
          year += parseInt(matches[1], 10);
          day = Math.min(day, daysInMonth(year, month));
          break;
        default:
          break;
      }
      matches = pattern.exec(offset);
    }
    return new Date(year, month, day);
  };
  let date = null;
  if (compute === null) date = defaultDate;
  else if (typeof compute === "string") date = offsetString(compute);
  else if (typeof compute === "number") {
    if (Number.isNaN(compute)) date = defaultDate;
    else date = offsetNumeric(compute);
  } else date = compute;
  date = date && date.toString() === "Invalid Date" ? defaultDate : date;
  if (date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
  }
  return date;
}

/* 数字每3位加逗号 */
export function toThousands(number) {
  let num = number;
  num = (num || 0).toString();
  let result = "";
  while (num.length > 3) {
    result = `,${num.slice(-3)}${result}`;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  return result;
}

// 秒数转换为时分秒格式
export function secondToZhTime(second) {
  let theTime = parseInt(second, 10); // 秒
  let theTime1 = 0; // 分
  let theTime2 = 0; // 小时
  if (theTime >= 60) {
    theTime1 = parseInt(theTime / 60, 10);
    theTime = parseInt(theTime % 60, 10);
    if (theTime1 >= 60) {
      theTime2 = parseInt(theTime1 / 60, 10);
      theTime1 = parseInt(theTime1 % 60, 10);
    }
  }
  let result = `${parseInt(theTime, 10)}秒`;
  result = `${parseInt(theTime1, 10)}分${result}`;
  if (theTime2 > 0) {
    result = `${parseInt(theTime2, 10)}时${result}`;
  }
  return result;
}

// 秒数转换为时分秒格式，只保留2项，秒四舍五入
export function secondToZhTime2(second) {
  let theTime = parseInt(second, 10); // 秒
  let theTime1 = 0; // 分
  let theTime2 = 0; // 小时
  const oldTime = theTime;
  if (theTime >= 60) {
    theTime1 = parseInt(theTime / 60, 10);
    theTime = parseInt(theTime % 60, 10);
    if (theTime >= 30 && oldTime >= 3600) {
      theTime1 += 1;
    }
    if (theTime1 >= 60) {
      theTime2 = parseInt(theTime1 / 60, 10);
      theTime1 = parseInt(theTime1 % 60, 10);
    }
  }
  let result = "";
  if (oldTime === 0) {
    result += `${parseInt(theTime, 10)}秒`;
  }
  if (oldTime < 3600 && theTime > 0) {
    result += `${parseInt(theTime, 10)}秒`;
  }
  if (theTime1 > 0) {
    result = `${parseInt(theTime1, 10)}分${result}`;
  }
  if (theTime2 > 0) {
    result = `${parseInt(theTime2, 10)}时${result}`;
  }
  return result;
}

/* 保留几位小数 */
export function toFixed(input, num) {
  return parseFloat((input || 0).toFixed(num || 1));
}

/* 绝对值 */
export function abs(input) {
  return Math.abs(input);
}

/* 数字转百分比（不带单位） */
export function percent(input) {
  return input ? parseFloat((input * 100).toFixed(1)) : "--";
}

/* 数字转百分比（带单位） */
export function percentWithUnit(input) {
  return input ? `${parseFloat((input * 100).toFixed(1))}%` : "--";
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    let milliTime = time;
    if (`${time}`.length === 10) milliTime = parseInt(time, 10) * 1000;
    date = new Date(milliTime);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = `0${value}`;
    }
    return value || 0;
  });
  return timeStr;
}

export function formatTime(time, option) {
  const milliTime = +time * 1000;
  const d = new Date(milliTime);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  }
  if (diff < 3600) {
    // less 1 hour
    return `${Math.ceil(diff / 60)}分钟前`;
  }
  if (diff < 3600 * 24) {
    return `${Math.ceil(diff / 3600)}小时前`;
  }
  if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(milliTime, option);
  }
  return `${d.getMonth() + 1}月${d.getDate()}日${d.getHours()}时${d.getMinutes()}分`;
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

export function downloadFile(content, filename, type = "text/plain") {
  const downLink = document.createElement("a");
  if (!("download" in downLink)) return false;
  downLink.download = filename;
  downLink.style.display = "none";
  // 字符串内容转blob地址
  const blobURL = new Blob([content], { type });
  downLink.href = URL.createObjectURL(blobURL);
  document.body.appendChild(downLink);
  downLink.click();
  document.body.removeChild(downLink);
  return true;
}

/* 生成图片url */
export function concatPicUrl(queryString, picBase) {
  if (/^http[s]{0,1}:\/\//.test(queryString)) {
    return queryString;
  }
  let qs = queryString;
  if (typeof queryString === "string") {
    qs = (queryString || "").split("&").reduce((t, c) => {
      const ps = c.split("=");
      if (ps.length > 1) {
        const [_, target, ...rest] = ps;
        t[ps[0]] = target;
      }
      return t;
    }, {});
  }
  const urls = picBase.split("?");
  const uri = urls[0];
  const qa = (urls.length > 1 ? urls[1] : "").split("&").reduce((t, c) => {
    const ps = c.split("=");
    if (ps.length > 1) {
      const [_, target, ...rest] = ps;
      t[ps[0]] = target;
    }
    return t;
  }, {});
  const rs = Object.assign({}, qa, qs);
  const params = Object.keys(rs).map(p => `${p}=${rs[p]}`);
  return uri + (params.length > 0 ? `?${params.join("&")}` : "");
}

/* load css */
export function loadCss(path) {
  return new Promise(resolve => {
    const head = document.getElementsByTagName("head")[0];
    const link = document.createElement("link");
    link.href = path;
    link.rel = "stylesheet";
    link.type = "text/css";
    head.appendChild(link);
    link.onload = () => {
      resolve(link);
    };
  });
}

/* 生成间隔interval的时间点，单位分钟 */
export function genMinuteRange(start = "10:00", end = "22:00", inter = 5) {
  const st = (start || "").split(":");
  let START_TIME = parseInt(st[0], 10) || 10;
  const START_MINUTE = st.length > 1 ? parseInt(st[1], 10) || 0 : 0;
  if (START_MINUTE > 0) {
    START_TIME += 1;
  }
  const et = (end || "").split(":");
  const END_TIME = parseInt(et[0], 10) || 22;
  const END_MINUTE = et.length > 1 ? parseInt(et[1], 10) || 0 : 0;
  const interval = parseInt(inter || "", 10) || 5;
  const range = {};
  let k = 0;
  // 非整点，前部分，比如9:40
  if (START_MINUTE > 0) {
    for (let i = START_MINUTE; i < 60; i += interval) {
      range[k] = `${START_TIME - 1 < 10 ? `0${START_TIME - 1}` : START_TIME - 1}:${
        i < 10 ? `0${i}` : i
      }`;
      k += 1;
    }
  }
  // 整点部分
  for (let j = START_TIME; j < END_TIME; j += 1) {
    for (let i = 0; i < 60; i += interval) {
      range[k] = `${j < 10 ? `0${j}` : j}:${i < 10 ? `0${i}` : i}`;
      k += 1;
    }
  }
  // 非整点，后部分 18:50
  if (END_MINUTE > 0) {
    for (let i = 0; i <= END_MINUTE; i += interval) {
      range[k] = `${END_TIME < 10 ? `0${END_TIME}` : END_TIME}:${i < 10 ? `0${i}` : i}`;
      k += 1;
    }
  } else {
    // 如果没有非整点，最后一个整点
    range[k] = `${END_TIME}:00`;
  }
  return range;
}

// 生成uuid
export function uuid(template) {
  return (template || "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx").replace(/[x]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
// 生成uuid
export function uuid2(template) {
  return (template || "xxxxxxxx").replace(/[x]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
export function trackTimeFormat(input) {
  const cur = Math.floor((input * 80) / 1000);
  // eslint-disable-next-line no-mixed-operators
  return `${Math.floor(cur / 3600)}:${Math.floor((cur % 3600) / 60)
    .toString()
    .padStart(2, 0)}:${(cur % 60).toString().padStart(2, 0)}`;
}
export function secondTimeFormat(input) {
  if (!input) {
    return "";
  }
  const cur = parseInt(input, 10);
  return `${Math.floor(cur / 3600)}:${Math.floor((cur % 3600) / 60)
    .toString()
    .padStart(2, 0)}:${(cur % 60).toString().padStart(2, 0)}`;
}
// channel转标准串
export function toStandardChannel(channel) {
  let itemChannel = `${channel}`;
  if (itemChannel.length < 4) {
    itemChannel = `1${itemChannel.padStart(3, "0")}`;
  }
  return `ch0${itemChannel}`;
}

export function inside(point, vs) {
  // ray-casting algorithm based on
  // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html

  const x = point[0];
  const y = point[1];

  let result = false;
  // eslint-disable-next-line
  for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
    const xi = vs[i][0];
    const yi = vs[i][1];
    const xj = vs[j][0];
    const yj = vs[j][1];

    const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) result = !result;
  }

  return result;
}

// k8s静态资源域名对应ip
// const k8sStaticUrls = [
//   // '192.168.9.15:35922', // static.aibee.cn
//   // '192.168.9.12:35922', // static.aibee.cn
//   '192.168.9.15:38005', // static1.aibee.cn
//   '192.168.9.16:38005', // static2.aibee.cn
//   '192.168.9.17:38005', // static3.aibee.cn
//   '192.168.9.18:38005', // static4.aibee.cn
//   '192.168.9.19:38005', // static5.aibee.cn
//   '192.168.9.20:38005', // static6.aibee.cn
// ];
const k8sStaticUrls = [
  // 'http://192.168.9.12:38000', // https://static.aibee.cn
  // 'http://192.168.9.15:38001',
  // 'http://192.168.9.16:38002',
  // 'http://192.168.9.17:38003',
  // 'http://192.168.9.18:38004',
  // 'http://192.168.9.19:38005',
  // 'http://192.168.9.20:38006',

  "https://static1.aibee.cn:39001",
  "https://static2.aibee.cn:39002",
  "https://static3.aibee.cn:39003",
  "https://static4.aibee.cn:39004",
  "https://static5.aibee.cn:39005",
  "https://static6.aibee.cn:39006"
];

// 随机域名资源
export function randomStatic(url) {
  // return (url || '').replace('static.aibee.cn', `static${Math.ceil(Math.random() * 6)}.aibee.cn`);
  return (url || "").replace(
    "http://static.aibee.cn",
    k8sStaticUrls[Math.floor(Math.random() * k8sStaticUrls.length)]
  );
  // return (url || '').replace('http://static.aibee.cn', `${window.location.protocol}//biaozhu-test.aibee.cn`);
}

export function isProdEnv() {
  return ["deploy.aibee.cn"].includes(location.host);
}
